import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import SelectAPI from './SelectAPI';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import CustomInput from './CustomInput';

class ParkingSpotCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      description: '',
      descriptionInvalid: false,
      date_start: '',
      dateStartInvalid: false,
      date_stop: '',
      dateStopInvalid: false,
      plate: '',
      plateInvalid: false,
      sector: null,
      sectorInvalid: false, 
      spots: null,
      spotsInvalid: false,
      vehicle_type: false,
      loading: false,
      error_message: '',
      color_message: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);
  }
  componentWillUpdate(nextProps, nextState) {
    // dispatching an action based on state change
    if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {
      this.setState({
        description: nextProps.editing.description,
        date_start: nextProps.editing.date_start,
        date_stop: nextProps.editing.date_stop,
        plate: nextProps.editing.plate,
        sector: (Boolean(nextProps.editing.vehicle_type) === true ? nextProps.editing.sector : null),
        spots: (Boolean(nextProps.editing.vehicle_type) === true ? nextProps.editing.spots: null),
        vehicle_type: !Boolean(nextProps.editing.vehicle_type)
      });
    }
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = (target.type==='checkbox'?target.checked:(target.name!=='plate'?target.value:target.value.toUpperCase()));
    // get tag name
    const name = target.name;
    // Set State
    this.setState({
      [name]: value
    });
  }
  toggle(refresh){
    this.setState({
      description: '',
      descriptionInvalid: false,
      date_start: '',
      dateStartInvalid: false,
      date_stop: '',
      dateStopInvalid: false,
      plate: '',
      plateInvalid: false,
      sector: null,
      sectorInvalid: false,
      spots: null,
      spotsInvalid: false,
      vehicle_type: false,
      error_message: '',
      color_message: '',
    });
    this.props.toggle(refresh);
  }
  valid_field(){
    var invalid = false;
    if (this.state.description.length<2 || this.state.description.length>50) {
      invalid = true;
      this.setState({descriptionInvalid : true});
    } else {
      this.setState({descriptionInvalid : false});
    }
    if (this.state.date_start.length<10 || this.state.date_start.length>10) {
      invalid = true;
      this.setState({dateStartInvalid : true});
    } else {
      this.setState({dateStartInvalid : false});
    }
    if (this.state.date_stop.length<10 || this.state.date_stop.length>10) {
      invalid = true;
      this.setState({dateStopInvalid : true});
    } else {
      this.setState({dateStopInvalid : false});
    }
    if (this.state.plate.length<7 || this.state.plate.length>8) {
      invalid = true;
      this.setState({plateInvalid : true});
    } else {
      this.setState({plateInvalid : false});
    }
    if(this.state.vehicle_type === false){
      if (this.state.sector===null || this.state.sector.length<=0) {
        invalid = true;
        this.setState({sectorInvalid: true});
      } else {
        this.setState({sectorInvalid: false});
      }
      if (this.state.spots===null || this.state.spots.length<=0) {
        invalid = true;
        this.setState({spotsInvalid: true});
      } else {
        this.setState({spotsInvalid: false});
      }
    }

    // Valid input
    if(invalid===true){
      return false;
    }

    // Success
    return true;
  }
  async register() {
    if(!this.valid_field()){
      return; 
    }
    this.setState({loading : true});
    let url = BaseService.ENDPOINT + 'admin/vehicle-resident';
    var msg_success = 'cadastrado';
    if(this.props.editing !== null){
      url += "/"+this.props.editing.id;
      msg_success = 'alterado';
    }

    // Convertendo os setores em string
    var sector_selects = [];
    for(var key in this.state.sector) {
      if(key==='id'){
        sector_selects = [this.state.sector[key]];
      } else if(key!=='name'){
        sector_selects[key] = this.state.sector[key]['id'];
      }
    }

    // Convertendo as vagas em string
    var spots_selects = [];
    for(key in this.state.spots) {
      if(key==='id'){
        spots_selects = [this.state.spots[key]];
      } else if(key!=='name'){
        spots_selects[key] = this.state.spots[key]['id'];
      }
    }

    // Enviando o formulário
    var form = new FormData();
    form.append("description", this.state.description);
    form.append("date_start", this.state.date_start);
    form.append("date_stop", this.state.date_stop);
    form.append("plate", this.state.plate);
    form.append("vehicle_type", this.state.vehicle_type === true ? 0 : 1);
    form.append("sector", sector_selects);
    form.append("spots", spots_selects);
    const response = await fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      body: form
    });
    const json = await response.json();
    if (json.return.code === 1) {
      this.setState({
        loading: true,
        error_message: 'Cadastro ' + msg_success + ' com sucesso nas vagas!',
        color_message: 'success'
      });
    }
    else if (json.return.code>300) {
      window.location = '/';
    }
    else {
      this.setState({
        loading: true,
        error_message: json.return.message
      });
    }
  }
  onChange = status => {
    if(status === "free"){
      this.setState({ vehicle_type: true })
    }
    else{
      this.setState({ vehicle_type: false })
    }
  }
  render() {
    var sector_selects = [];
    for(var key in this.state.sector) {
      if(key==='id'){
        sector_selects = [this.state.sector[key]];
      } else if(key!=='name'){
        sector_selects[key] = this.state.sector[key]['id'];
      }
    }
    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>{(this.props.editing!==null?'Editar':'Cadastrar')} Veículo do Morador</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <FormGroup>
                {(this.props.editing!==null?<Label>Descrição</Label>:'')}
                <Input
                  type="text"
                  maxLength={50}
                  name="description"
                  placeholder="Descrição"
                  value={this.state.description}
                  onChange={this.handleInputChange}
                  invalid={this.state.descriptionInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <CustomInput
                label={(this.props.editing!==null?'Data Inicial':'')}
                invalid={this.state.dateStartInvalid}
                mask={"00/00/0000"}
                name="date_start"
                placeholder='Data Inicial'
                value={this.state.date_start}
                onChange={(value) => {this.setState({date_start: value})}}
                unmask={false}
                invalid_message={Strings.required_field}
              />
              <CustomInput
                label={(this.props.editing!==null?'Data Final':'')}
                invalid={this.state.dateStopInvalid}
                mask={"00/00/0000"}
                name="date_stop"
                placeholder='Data Final'
                value={this.state.date_stop}
                onChange={(value) => {this.setState({date_stop: value})}}
                unmask={false}
                invalid_message={Strings.required_field}
              />
              <FormGroup>
                {(this.props.editing!==null?<Label>Placa</Label>:'')}
                <Input
                  type="text"
                  maxLength={8}
                  name="plate"
                  placeholder="Placa"
                  value={this.state.plate}
                  onChange={this.handleInputChange}
                  invalid={this.state.plateInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <RadioGroup onChange={ this.onChange } value={this.state.vehicle_type === true ? "free" : "dweller"}>
                <RadioButton value="dweller" pointColor="green" rootColor="#808080" iconSize={20} iconInnerSize={10}>
                  Veiculo Morador
                </RadioButton>
                <RadioButton value="free" pointColor="green" rootColor="#808080" iconSize={20} iconInnerSize={10}>
                  Veiculo Isento
                </RadioButton>
              </RadioGroup>
              <div hidden={this.state.vehicle_type}>
                <SelectAPI
                  label={(this.props.editing!==null?Strings.sector:'')}
                  name="sector"
                  placeholder={"Selecione uma "+Strings.sector}
                  access_token={this.props.user.access_token}
                  api="admin/parking-spot-sector"
                  selectedOption={this.handleInputChange}
                  value={this.state.sector}
                  invalid={this.state.sectorInvalid} 
                  formFeedbackMsg={Strings.required_field}
                  multi={true}
                />
                <SelectAPI
                  label={(this.props.editing!==null?Strings.spot:'')}
                  name="spots"
                  method="POST"
                  formInput={(sector_selects==null?'':sector_selects)}
                  placeholder={"Selecione uma "+Strings.spot}
                  access_token={this.props.user.access_token}
                  api="admin/parking-spot-select"
                  selectedOption={this.handleInputChange}
                  value={this.state.spots}
                  invalid={this.state.spotsInvalid} 
                  formFeedbackMsg={Strings.required_field}
                  multi={true}
                />
              </div>
            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading}>
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={() => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
    </Modal>
    )
  }
}
export default ParkingSpotCreate;


// WEBPACK FOOTER //
// ./src/components/VehicleResidentCreate.js